export const GET_MUSIC = "GET_MUSIC";
export const GET_ONE_MUSIC = "GET_ONE_MUSIC";
export const ADD_MUSIC = "ADD_MUSIC";
export const UPDATE_MUSIC = "UPDATE_MUSIC";
export const ERRORS = "ERRORS";
export const LOADING = "LOADING";
